<template>
  <div>
  <el-header style="padding: 0px;display:flex;justify-content:flex-start;align-items: center">
    读取状态:
    <el-select v-model="status" clearable  style="width: 130px" size="small" placeholder="请选择状态">
      <el-option
        v-for="item in allStatus"
        :key="item.id"
        :label="item.label"
        :value="item.id">
      </el-option>
    </el-select>
    <div style="margin-left: 150px;width: 500px;">
      <el-input placeholder="请输入内容" v-model="keyWord" class="input-with-select">
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
     </div>
  </el-header>
   <el-table
    :data="msgs"
    border
    stripe
    size="small"
    width="90%"
    >
    <el-table-column
      fixed
      type="index"
      width="50">
    </el-table-column>
    <el-table-column
      prop="title"
      align="left"
      fixed
      width="100"
      label="标题"
      >
    </el-table-column>
    <el-table-column
      prop="msgContent"
      align="left"
      label="(短信/邮件/钉钉)消息内容"
      >
    </el-table-column>
     <el-table-column
       prop="voiceMsg"
       label="语音消息内容"
     >
     </el-table-column>
    <el-table-column
      align="left"
       width="90"
      label="创建日期"
      prop="createdTime">
    </el-table-column>
    <el-table-column
      prop="sendType"
      align="right"
      width="100"
      label="发送方式"
      >
    </el-table-column>
        <el-table-column
          prop="sendTo"
          align="right"
          width="70"
          :formatter="sendToFormat"
          label="接收者"
          >
        </el-table-column>
    <el-table-column
      prop="status"
      align="right"
      width="80"
      :formatter="stateFormat"
      label="发送状态"
      >
    </el-table-column>
    <el-table-column
      prop="readFlg"
      align="right"
      width="80"
      v-if=false
      :formatter="statusFormat"
      label="读取状态"
      >
    </el-table-column>
  </el-table>
  <el-pagination
    background
    :page-size="pageSize"
    :current-page="currentPage"
    @current-change="currentChange"
    layout="total,prev,pager,next"
    :total="totalCount">
  </el-pagination>
  </div>
</template>
<script>
  export default{
    data(){
      return {
        pageSize: 10,
        totalCount: -1,
        currentPage: 1,
        changeType: '',
        createdDate: '',
        status: 'N',
        keyWord: '',
        advanceSearchViewVisible: true,
        dialogVisible: false,
        dialogLoading: false,
        title: '',
        message: '',
        allUsers:[],
        allGroups: [],
        mid: -1,
        msgs: [],
        faangledoubleup: 'fa-angle-double-up',
        faangledoubledown: 'fa-angle-double-down',
        allStatus: [
        {
            id: 'Y',
            label: '已读'
          }, {
            id: 'N',
            label: '未读'
          }],

      }
    },
    watch: {
      status(val) {
        this.initSysMsgs();
      }
    },
    mounted() {
      this.initSysMsgs();
      this.loadAllUsers();
      this.loadAllGroups();
    },
    methods: {
      loadAllGroups(){
        let _this = this;
        this.getRequest("/api/chatGroup/getChatInfo?name=&status=active").then(resp => {
          if (resp && resp.status == 200) {
            _this.allGroups = resp.data.chats;
          }
        });
      },
      search(){
        this.pageSize=10;
        this.currentPage=1;
        this.initSysMsgs();
      },
         initSysMsgs(){
         let _this = this;
         if(this.status=='N'){
            this.pageSize = 1000;
         }else{
            this.pageSize = 10;
         }
           this.getRequest("/api/msg/getMsg?page=" + this.currentPage + "&size="+this.pageSize+"&readFlag=" + this.status+"&keyWord=" + this.keyWord).then(resp=> {
            _this.msgs = resp.data.msgs;
            _this.totalCount = resp.data.count;
           });
       },
      statusFormat(row, column){
          if (row.status == 'N') {
            return '未读'
          } else  {
            return '已读'
          }
      },
      stateFormat(row, column){
          if (row.status == 'success') {
            return '成功'
          } else  {
            return '失败'
          }
      },
      sendToFormat(row, column){
      let _this = this;
        let nameStr = '';
        let to = row.sendTo.split(',');
        to.forEach(code =>{
          _this.allUsers.forEach(item =>{
            if(item.empCode == code){
               nameStr= nameStr+item.name+',';
             }
          })
          _this.allGroups.forEach(item =>{
            if(item.chatId == code){
               nameStr= nameStr+item.name+',';
             }
          })
        })
        return nameStr.substring(0, nameStr.length - 1);
      },
      loadAllUsers(){
        let _this = this;
        this.getRequest("/api/user/getUserInfo?name=&status=active").then(resp=> {
          if (resp && resp.status == 200) {
            _this.allUsers = resp.data.users;
          }
        });
      },
    currentChange(currentChange){
      this.currentPage = currentChange;
      this.initSysMsgs();
     }

  }
  }
</script>



// WEBPACK FOOTER //
// src/components/chat/Notification.vue